<template>
  <div>
    <mdbRow>
      <mdbCol col="12" v-if="!carouselsLoaded">
        <mdbSpinner small />
        <h5>{{ $t("loading_carousels") }}</h5>
      </mdbCol>
      <mdbCol v-if="carouselsLoaded">
        <mdb-btn color="indigo" @click="startFetchingcarouselsExcel">{{
          $t("load_carousels_excel")
        }}</mdb-btn>
        <ListSelection
          :List="carouselslist"
          :Label="$t('carousels')"
          :Placeholder="$t('choose_carousel')"
          @selection="carouselsListSelection"
        />
      </mdbCol>
    </mdbRow>
    <mdbRow>
      <mdbCol>
        <mdb-btn
          data-html2canvas-ignore="true"
          @click="carouselReportPrint"
          color="primary"
          size="sm"
          >{{ $t("advertisement_preview_save") }}</mdb-btn
        >
      </mdbCol>
      <mdbCol>
        <mdb-input
          :label="$t('impression_start_date')"
          type="date"
          v-model="impressionStartDate"
        />
      </mdbCol>
      <mdbCol>
        <mdb-input
          :label="$t('impression_end_date')"
          type="date"
          v-model="impressionEndDate"
        />
      </mdbCol>
    </mdbRow>
    <div id="carouselReportPreview">
      <mdbRow style="background-color: #2b2e34">
        <mdbCol class="mt-3 mb-3">
          <img
            src="../assets/img/cityshoppari_logo_valkoinen_web.png"
            :width="250"
            alt="..."
          />
        </mdbCol>
      </mdbRow>
      <mdbRow class="mt-3">
        <mdbCol col="6">
          <div class="center-cropped">
            <img :src="carouselImage" alt="..." />
          </div>
        </mdbCol>
        <mdbCol col="6">
          <H5>{{ selectedRetailer }}</H5>
          <H6>{{ selectedTitle }}</H6>
        </mdbCol>
      </mdbRow>
      <mdbRow class="mb-5 mt-3" v-if="carouselEventsLoaded">
        <mdbCol>
          <div class="chart-size">
            <BarChartBasic
              :key="refreshCounter"
              :data="carouselImpressions"
              :label="$t('carousel_impressions')"
              :height="height"
            />
          </div>
        </mdbCol>
      </mdbRow>
      <mdbRow class="mt-5" v-if="carouselEventsLoaded">
        <mdbCol>
          <div class="chart-size">
            <BarChartBasic
              :key="refreshCounter"
              :data="carouselClicks"
              :label="$t('carousel_clicks')"
              :height="height"
            />
          </div>
        </mdbCol>
      </mdbRow>
    </div>
  </div>
</template>

<script>
import { mdbRow, mdbCol, mdbBtn, mdbSpinner, mdbInput } from "mdbvue";
import ListSelection from "../components/ListSelection.vue";
import BarChartBasic from "@/components/BarChartBasic";
import { saveAs } from "file-saver";
export default {
  name: "LoadcarouselReport",
  components: {
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbSpinner,
    ListSelection,
    BarChartBasic,
    mdbInput,
  },
  data() {
    return {
      height: "350",
      imageWidth: "960",
      imageHeight: "540",
      refreshCounter: 0,
      currentTable: [],
      carouselslist: [],
      selectedcarousel: null,
      carousels: null,
      carouselImage: null,
      selectedRetailer: "",
      selectedTitle: "",
      carouselEvents: null,
      carouselClicks: null,
      carouselImpressions: [],
      memberSearchModal: false,
      carouselsLoaded: false,
      carouselEventsLoaded: false,
      carouselspath: "/1.0/front/carousels",
      carouseleventspath: "/1.0/front/carousel/",
      carouselexcelreportpath: "/2.0/carousels/report?sessionid=",
      impressionStartDate: undefined,
      impressionEndDate: undefined,
    };
  },
  mounted() {
    this.getcarousels();
  },
  methods: {
    carouselReportPrint() {
      this.printHtml2PdfAsIs(
        "carouselReportPreview",
        "carouselReportPreview.pdf"
      );
    },
    startFetchingcarouselsExcel() {
      this.$http
        .get(this.carouselexcelreportpath + this.$store.getters.getToken, {
          responseType: "blob",
          timeout: 30000,
        })
        .then((response) => {
          if (response.status == 200) {
            saveAs(response.data, "carousels-report.xlsx");
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          window.__logAxiosErrorIfDebug(error, {
            context: "LoadBannerReport.vue - startFetchingcarouselsExcel",
          });
          this.$root.$emit("session_failed");
          return error;
        });
    },
    carouselsListSelection(val) {
      this.selectedcarousel = val;
      this.carouselEventsLoaded = false;
      this.$http
        .get(
          this.carouseleventspath +
            val +
            "?sessionid=" +
            this.$store.getters.getToken
        )
        .then((response) => {
          if (response.status == 200) {
            this.carouselEvents = response.data.carousels[0];
            this.createcarouselEventsGraph();
            this.carouselEventsLoaded = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          window.__logAxiosErrorIfDebug(error, {
            context: "LoadBannerReport.vue - carouselsListSelection",
          });
          this.$root.$emit("session_failed");
          return error;
        });
      console.log(val);
    },
    getcarousels() {
      this.carouselsLoaded = false;
      this.$http
        .get(this.carouselspath)
        .then((response) => {
          if (response.status == 200) {
            this.carousels = response.data.carousels;
            this.fillcarouselList();
            this.carouselsLoaded = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          window.__logAxiosErrorIfDebug(error, {
            context: "LoadBannerReport.vue - getcarousels",
          });
          this.$root.$emit("session_failed");
          return error;
        });
    },
    fillcarouselList() {
      this.carouselslist = [];
      this.carousels.forEach((element) => {
        this.carouselslist.push({
          text: element.title + ", " + element.retailer,
          value: element.id,
        });
      });
    },
    createcarouselEventsGraph() {
      this.carouselClicks = [];
      this.carouselImpressions = [];
      this.carousels.filter((carousel) => {
        if (carousel.id == this.selectedcarousel)
          this.carouselImage = "data:image/png;base64," + carousel.image;
        this.selectedRetailer = carousel.retailer;
        this.selectedTitle = carousel.title;
      });
      this.carouselClicks = this.carouselEvents.clicks;
      this.carouselEvents.impressions.forEach((element) => {
        let currentdate = new Date(element.eventday);
        let startdate = new Date(this.impressionStartDate);
        let enddate = new Date(this.impressionEndDate);
        if (currentdate > startdate && currentdate < enddate) {
          this.carouselImpressions.push(element);
        }
      });
    },
  },
  watch: {
    impressionStartDate() {
      this.refreshCounter += 1;
      this.createcarouselEventsGraph();
    },
    impressionEndDate() {
      this.refreshCounter += 1;
      this.createcarouselEventsGraph();
    },
  },
};
</script>

<style scoped>
#carouselReportPreview {
  max-width: 960px !important;
}
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}

.center-cropped img {
  width: 200px;
  height: auto;
}

.chart-size {
  width: 960px;
  height: 350px;
}
</style>
